
export default {
  inserted(el, binding) {
    // //////////////////////////////////////////////////
    function loadIamge() {
      if (el.dataset.src || el.dataset.defaultSrc) {
        const img = new Image()
        img.src = el.dataset.src || el.dataset.defaultSrc
        img.onload = () => {
          el.style.backgroundImage = `url(${img.src})`
          setTimeout(() => {
            el.style.opacity = 1
          }, 60)
        }
        img.onerror = (err) => {
          console.error('Image load error', err)
          if (el.dataset.defaultSrc) {
            el.style.backgroundImage = `url(${el.dataset.defaultSrc})`
            setTimeout(() => {
              el.style.opacity = 1
            }, 60)
          }
        }
      }
    }
    // //////////////////////////////////////////////////
    function checking() {
      const windowHeight = window.innerHeight || document.documentElement.clientHeight
      const windowPageYOffset = window.pageYOffset
      const bundle = el.getBoundingClientRect()
      if (windowHeight + windowPageYOffset > bundle.top) {
        window.removeEventListener('scroll', checking)
        window.removeEventListener('resize', checking)
        window.removeEventListener('orientationchange', checking)
        loadIamge()
      } else {
        return false // pass
      }
    }
    // //////////////////////////////////////////////////
    if (el.dataset.hide) {
      el.style.opacity = 0
    }
    el.style.transition = 'opacity .2s ease-in'
    el.style.backgroundColor = '#ececec'
    el.style.backgroundRepeat = 'no-repeat'
    el.style.backgroungPosition = 'center'
    el.style.backgroungSize = 'cover'

    window.addEventListener('scroll', checking)
    window.addEventListener('resize', checking)
    window.addEventListener('orientationchange', checking)
    checking()
  },
  bind(el, binding) {
    //
  },
  update(el, binding) {
    if (el.dataset.src) {
      const img = new Image()
      img.src = el.dataset.src
      img.onload = () => {
        el.style.backgroundImage = `url(${img.src})`
        setTimeout(() => {
          el.style.opacity = 1
        }, 60)
      }
      img.onerror = (err) => {
        console.error('Image load error', err)
        if (el.dataset.defaultSrc) {
          el.style.backgroundImage = `url(${el.dataset.defaultSrc})`
          setTimeout(() => {
            el.style.opacity = 1
          }, 60)
        }
      }
    }
  }
}
